export function ExportIcon({ width, height, className }: React.SVGProps<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "18"}
      height={height || "18"}
      fill="none"
      viewBox="0 0 18 18"
      className={className}
    >
      <path
        d="M9.8125 8.1875L16.475 1.525M17.125 4.775V0.875H13.225M8.1875 0.875H6.5625C2.5 0.875 0.875 2.5 0.875 6.5625V11.4375C0.875 15.5 2.5 17.125 6.5625 17.125H11.4375C15.5 17.125 17.125 15.5 17.125 11.4375V9.8125"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
